"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var styles_1 = require("@mui/material/styles");
var Common_module_css_1 = __importDefault(require("./Common.module.css"));
var AutoCompleteTheme = (0, styles_1.createTheme)({
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontFamily: "'Geomanist', sans-serif",
                    color: "var(--info-color)",
                },
                paper: {
                    borderRadius: "0px 0px 14px 14px",
                    marginLeft: "-5px",
                },
                popupIndicator: {
                    "& .MuiSvgIcon-root": {
                        color: "var(--primary-color-tinted)",
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: "transparent",
                            width: "100%",
                        },
                        "&:hover fieldset": {
                            borderColor: "transparent",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "transparent",
                        },
                    },
                    "& .MuiFormLabel-root": {
                        color: "var(--info-color)",
                        "&.Mui-focused": {
                            display: "none",
                        },
                    },
                },
            },
        },
    },
});
var AutocompleteUserSelection = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: AutoCompleteTheme },
        react_1.default.createElement(Autocomplete_1.default, { onChange: function (event, newValue) {
                var memberId = props.member ? props.member.id : null;
                props.handleMemberSelectionChange(memberId, newValue ? newValue.id : null);
            }, options: props.users, getOptionLabel: function (option) { return option.name || ""; }, noOptionsText: t("No options"), renderInput: function (params) { return (react_1.default.createElement(TextField_1.default, __assign({}, params, { label: props.label, variant: "outlined", size: "small", "data-cy": "addMemberInput", InputLabelProps: {
                    style: {
                        top: "50%",
                        transform: "translate(0, -50%)",
                        marginLeft: "10px",
                    },
                } }))); }, ListboxProps: {
                className: Common_module_css_1.default["autocomplete-list-box"],
                style: {
                    maxHeight: "150px",
                    overflow: "auto",
                }
            } })));
};
exports.default = AutocompleteUserSelection;
